import PropTypes from 'prop-types'
import React from 'react'

const Borde = React.forwardRef(
  ({ name, titulo, tituloOculto, activo, error, children, className }, ref) => {
    const obtenerClases = () => {
      let clase = 'borde-normal'
      if (activo) {
        clase += '-active'
      }
      clase += ' paso-publicar'
      if (activo) {
        clase += ' paso-publicar-activo'
      }
      if (error) {
        clase += ' error'
      }

      return clase
    }

    return (
      <div className={`row ${className || ''}`} disabled={!activo}>
        <div className="col-2 d-none d-lg-block" />
        <div className="col">
          <div className={obtenerClases()} ref={ref}>
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            {!tituloOculto && (
              <h3 id={name} name={name} className="paso-publicar-titulo">
                {titulo}
              </h3>
            )}
            {children}
          </div>
        </div>
        <div className="col-2 d-none d-lg-block" />
      </div>
    )
  }
)

Borde.displayName = 'Borde'

Borde.propTypes = {
  name: PropTypes.string,
  titulo: PropTypes.string,
  tituloOculto: PropTypes.bool,
  activo: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
}

export default Borde
